import { User } from 'src/ui/graph/types';

export const getUserInfo = (user: Partial<User> | undefined | null) => {
  if (user && user.id) {
    const firstName = user.first_name || '';
    const lastName = user.last_name || '';
    const email = user.email || '';
    return {
      id: user.id,
      initials: [firstName[0], lastName[0]].filter(Boolean).join(''),
      name: [firstName, lastName].filter(Boolean).join(' '),
      email,
    };
  }
  return null;
};
